<span class="pill" [ngClass]="classes">
  @if (squareLetter) {
    <i class="fa-solid fa-square-{{ squareLetter }}"></i>
  }
  <span class="pill-label"><ng-content></ng-content></span>
  @if (value != null) {
    <span class="pill-value">: {{ value }}</span>
  }
  @if (removable) {
    <span class="pill-remove" (click)="onRemove($event)">
      <i class="fa-solid fa-xmark"></i>
    </span>
  }
</span>
